import { BaseDto } from "src/dtos/common/baseDto";

export interface TqcInspectItemDto extends BaseDto {
	itemCd: string;
	inspType: string;
	inspTypeNm: string;
	inspItemCd: string;
	inspItemNm: string;
	inspItemUsage: string;
	remark: string;

	// 기존 검사 화면에서 함께 사용하는 검사기준 필드

	inserted: boolean;
	isModified: boolean;
}

export const defaultTqcInspectItemDto: TqcInspectItemDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	itemCd: '',
	inspType: '',
	inspTypeNm: '',
	inspItemCd: '',
	inspItemNm: '',
	inspItemUsage: '',
	remark: '',


	inserted: false,
	isModified: false,
};
